import React from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../../components/ui/dropDown";
import { Button } from "@material-ui/core";
import { Filter, Search } from "lucide-react";
import { useMediaQuery } from "@mui/material";
import { Input } from "../../../components/ui/input";

const FilterOrders = (props) => {
  const { setPriorityFilter, setStatusFilter, searchTerm, setsearchTerm } =
    props;
  const isMobile = useMediaQuery("(max-width:767px)");

  return (
    <div className="d-flex flex-space-between">
      <div className="relative mb-4 w-65">
        <Search
          className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-500"
          size={18}
        />
        <Input
          placeholder="Search orders..."
          className="pl-40 bg-white dark:bg-[#0F1729]"
          value={searchTerm ? searchTerm : ""}
          onChange={(event) => {
            setsearchTerm(event.target.value);
          }}
        />
      </div>
     <div>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button
            variant="outlined"
            className={
              isMobile
                ? "flex items-center gap-1 mt-0"
                : "flex items-center gap-1 ml-8"
            }
            style={{ height: "40px" }}
          >
            <Filter className="h-4 w-8 dark:text-white" />
            <span className="hidden sm:inline dark:text-white">Filters</span>
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent
          align="end"
          className="w-56 dark:bg-[#1A1F2C] dark:text-white bg-white"
          style={{ zIndex: "9999px"}}
        >
          <div className="p-2 font-semibold border-b dark:border-gray-700">Status</div>
          <DropdownMenuItem onClick={() => setStatusFilter("All")} className="dark:hover:bg-gray-700">
            All Statuses
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setStatusFilter("Ordered")} className="dark:hover:bg-gray-700">
            Ordered
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setStatusFilter("In Process")} className="dark:hover:bg-gray-700">
            In Process
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setStatusFilter("Shipped")} className="dark:hover:bg-gray-700">
            Shipped
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setStatusFilter("Delivered")} className="dark:hover:bg-gray-700">
            Delivered
          </DropdownMenuItem>

          <div className="p-2 font-semibold border-b border-t mt-2 dark:border-gray-700">
            Priority
          </div>
          <DropdownMenuItem onClick={() => setPriorityFilter("All")} className="dark:hover:bg-gray-700">
            All Priorities
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setPriorityFilter("1")} className="dark:hover:bg-gray-700">
            High
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setPriorityFilter("2")} className="dark:hover:bg-gray-700">
            Medium
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => setPriorityFilter("3")} className="dark:hover:bg-gray-700">
            Low
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
     </div>
    </div>
  );
};

export default FilterOrders;
